import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=08002968&scoped=true"
import script from "./table_form.vue?vue&type=script&lang=js"
export * from "./table_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08002968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08002968')) {
      api.createRecord('08002968', component.options)
    } else {
      api.reload('08002968', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=08002968&scoped=true", function () {
      api.rerender('08002968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/announcement-management/form/components/table_form.vue"
export default component.exports